module.exports = __webpack_public_path__ + "img/promo.46c7f5f.jpg";